/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function GripDotsVerticalIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M16 12c-1.125 0-2-.875-2-2 0-1.062.875-2 2-2 1.063 0 2 .938 2 2 0 1.125-.937 2-2 2m0 10c-1.125 0-2-.875-2-2 0-1.062.875-2 2-2 1.063 0 2 .938 2 2 0 1.125-.937 2-2 2m2 8c0 1.125-.937 2-2 2-1.125 0-2-.875-2-2 0-1.062.875-2 2-2 1.063 0 2 .938 2 2m6-18c-1.125 0-2-.875-2-2 0-1.062.875-2 2-2 1.063 0 2 .938 2 2 0 1.125-.937 2-2 2m2 8c0 1.125-.937 2-2 2-1.125 0-2-.875-2-2 0-1.062.875-2 2-2 1.063 0 2 .938 2 2m-2 12c-1.125 0-2-.875-2-2 0-1.062.875-2 2-2 1.063 0 2 .938 2 2 0 1.125-.937 2-2 2"/>}
        </IconWrapper>);
}
